// extracted by mini-css-extract-plugin
export default {"searchResultLink":"style__searchResultLink___34Zaj","searchSeparator":"style__searchSeparator___3BiLY","itemCode":"style__itemCode___zF-Tp"};